import type { PurchasingSpendSummary } from "@/lib/manufacturing/purchaseOrderSpend";

function money(n: number): string {
  return n.toLocaleString(undefined, { style: "currency", currency: "USD" });
}

export function ManufacturingPurchasingSpendStrip(props: {
  summary: PurchasingSpendSummary;
  onOrderLineCount: number;
}) {
  const { summary } = props;
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
      <div className="rounded-lg border border-gray-200 px-3 py-2 dark:border-zinc-700">
        <div className="text-[11px] font-medium text-gray-500 dark:text-zinc-400">
          PO expected
        </div>
        <div className="text-sm font-semibold text-gray-900 dark:text-zinc-100">
          {money(summary.expectedUsd)}
        </div>
        <div className="text-[10px] text-gray-500">{summary.openPoCount} open</div>
      </div>
      <div className="rounded-lg border border-gray-200 px-3 py-2 dark:border-zinc-700">
        <div className="text-[11px] font-medium text-gray-500 dark:text-zinc-400">
          Invoice confirmed
        </div>
        <div className="text-sm font-semibold text-gray-900 dark:text-zinc-100">
          {money(summary.invoicedUsd)}
        </div>
        <div className="text-[10px] text-gray-500">
          {summary.needsInvoiceCount} waiting on invoice
        </div>
      </div>
      <div className="rounded-lg border border-gray-200 px-3 py-2 dark:border-zinc-700">
        <div className="text-[11px] font-medium text-gray-500 dark:text-zinc-400">
          Chargebacks
        </div>
        <div className="text-sm font-semibold text-gray-900 dark:text-zinc-100">
          {money(summary.chargebackUsd)}
        </div>
        <div className="text-[10px] text-gray-500">
          {summary.needsDeliveryCount} waiting on delivery
        </div>
      </div>
      <div className="rounded-lg border border-gray-200 px-3 py-2 dark:border-zinc-700">
        <div className="text-[11px] font-medium text-gray-500 dark:text-zinc-400">
          On order (uncommitted)
        </div>
        <div className="text-sm font-semibold text-gray-900 dark:text-zinc-100">
          {props.onOrderLineCount} material{props.onOrderLineCount === 1 ? "" : "s"}
        </div>
        <div className="text-[10px] text-gray-500">
          Net accepted {money(summary.netAcceptedUsd)}
        </div>
      </div>
    </div>
  );
}
